const getLineItemBody = (lineItem, labels)=>{
    if (lineItem.type === 'contact-lenses') {
        const eyeSideLabel = lineItem.eyeSide === 'left' ? labels.leftEye : labels.rightEye;
        return `${labels.quantity}: ${lineItem.quantity} | ${eyeSideLabel}`;
    }
    if (lineItem.type === 'contact-lenses-bundle-benelux') {
        return labels.monthlySubscription;
    }
    if (lineItem.type === 'sunglasses' || lineItem.type === 'ready-readers' || lineItem.type === 'accessories') {
        const { model , modelCode  } = lineItem.brand;
        return `${model}${modelCode && modelCode !== model ? ` ${modelCode}` : ''}${lineItem.type === 'ready-readers' && (lineItem === null || lineItem === void 0 ? void 0 : lineItem.power) ? ` | ${labels.power}: ${lineItem.power}` : ''}`;
    }
    if (lineItem.type === 'solutions') {
        return `${lineItem.solutionType}, ${lineItem.solutionVolume}${labels.unitMilli}`;
    }
    // TODO: Add body text for prescription glasses
    return '';
};

export { getLineItemBody };
//# sourceMappingURL=get-product-body.js.map
